import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { Box, Button, SubHeading } from '@components/common';
import { InputField, PhoneField } from '@components/form';
import API from '@utils/api';
import validationSchema from './schema';
import AuthActions, { AuthSelectors } from '@redux/AuthRedux';
import { trackAccountEdit } from '@services/analytics';
import { getErrors } from '@utils/error';

class EditAccountForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    updateUser: PropTypes.func,
    user: PropTypes.object
  };

  handleSubmit = async (values, actions) => {
    const { user, updateUser, onSubmit } = this.props;
    const { setSubmitting, setErrors } = actions;
    setSubmitting(true);
    const { optInNewsLetter, hasPets } = user;

    try {
      await API.updateBasicProfile({
        optInNewsLetter,
        hasPets,
        ...values
      });
      setSubmitting(false);
      trackAccountEdit(values);
      updateUser({
        ...user,
        ...values
      });
      onSubmit();
    } catch (err) {
      const error = getErrors(err);
      const errors = {
        phone: error.message || 'Submitted data is not valid'
      };

      setErrors(errors);
    }
    setSubmitting(false);
  };

  render() {
    const { user } = this.props;
    const { email, firstName, lastName, phone } = user;
    const { onCancel } = this.props;

    const initialFormValues = {
      email,
      firstName,
      lastName,
      phone
    };

    return (
      <Formik
        initialValues={initialFormValues}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
        initialErrors={validationSchema.isValidSync(initialFormValues)}
      >
        {({ isValid, isSubmitting }) => {
          return (
            <Form>
              <Box display="flex" flexDirection="column">
                <SubHeading textAlign="center" fontWeight="bold" mt={4} mb={4}>
                  Edit My Details
                </SubHeading>
                <Field
                  component={InputField}
                  mb={4}
                  name="email"
                  type="email"
                  label="Email"
                />
                <Field
                  component={InputField}
                  mb={4}
                  name="firstName"
                  type="text"
                  label="First Name"
                />
                <Field
                  component={InputField}
                  mb={4}
                  name="lastName"
                  type="text"
                  label="Last Name"
                />
                <Field
                  component={PhoneField}
                  mb={4}
                  name="phone"
                  type="text"
                  label="Phone"
                />
                <Box flex={1} mb={4} display="flex" flexDirection="row">
                  <Button
                    variant="secondary"
                    flex={1}
                    mr={4}
                    type="button"
                    onClick={() => {
                      onCancel();
                    }}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </Button>
                  <Button
                    flex={1}
                    type="submit"
                    disabled={!isValid || isSubmitting}
                  >
                    Done
                  </Button>
                </Box>
              </Box>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state)
});

const mapDispatchToProps = dispatch => ({
  updateUser: newUserInfo => dispatch(AuthActions.setUser(newUserInfo))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(EditAccountForm);
